export default {
  ACCOUNT_OPEN_SUCCESS_HEADER_1: "You did it!",
  ACCOUNT_OPEN_SUCCESS_HEADER_2: "Your account is open.",
  ACCOUNT_OPEN_SUCCESS_SUBHEADING_1:
    "You'll receive a copy of your investment documents via email.",
  ACCOUNT_OPEN_SUCCESS_SUBHEADING_2: "The following is your target portfolio",
  SHOWABLE_ITEMS: [
    [
      {
        label: "VTI",
        value: 238.21,
      },
      {
        label: "10% of portfolio",
      },
      {
        label: "Vanguard Total Stock Market Index Fund ETF",
      },
    ],
    [
      {
        label: "VXUS",
        value: 62.73,
      },
      {
        label: "10% of portfolio",
      },
      {
        label: "Vanguard Total International Stock ETF",
      },
    ],
    [
      {
        label: "BND",
        value: 85.26,
      },
      {
        label: "80% of portfolio",
      },
      {
        label: "Vanguard Total Bond Market Index Fund ETF",
      },
    ],
  ],
  ACCOUNT_OPEN_SUCCESS_CONTENT_1: (amount) =>  `We are only taking investments of $${amount} USD at this time.`,
  ACCOUNT_OPEN_SUCCESS_CONTENT_2: 'By selecting "Buy Assets", you give us permission to execute trades and invest funds that originate from the account below.',
  ACCOUNT_OPEN_SUCCESS_BUTTON_HEADING: "Buy Assets",
};
